import { render, staticRenderFns } from "./DashAttackTech.vue?vue&type=template&id=bc1b17b0&"
import script from "./DashAttackTech.vue?vue&type=script&lang=ts&"
export * from "./DashAttackTech.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports